import { render } from "./LogoImg.vue?vue&type=template&id=246c5c94"
import script from "./LogoImg.vue?vue&type=script&lang=ts"
export * from "./LogoImg.vue?vue&type=script&lang=ts"
script.render = render

export default script